import { List } from "immutable";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import SplitButton from "../../components/form/SplitButton";
import { PropTypeShapes } from "../../types";
import { wrapEditingComponent } from "../../utils/codeSplit";

// import debugUtils from "../../utils/debugUtils";

class NarrativeAddNodeView extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  // componentWillReceiveProps(nextProps) {
  //   debugUtils.logPropChanges("NarrativeAddNodeView", this.props, nextProps);
  // }

  render() {
    let orientationStyle = "horizontal";
    if (this.props.depth >= this.props.narrativeViewSettings.columnLevel) {
      orientationStyle = "vertical";
    }

    const nodeStyle = {
      left: `${this.props.x}px`,
      top: `${this.props.y}px`,
      width: this.props.width ? `${this.props.width}px` : "100%"
    };

    const onClick = _e => this.props.onClick();

    const optionGroups = List([
      {
        title: "Create New",
        id: "addNew",
        options: this.props.orderedNarrativeTypes,
        showTitle: this.props.availableItems ? !!this.props.availableItems.size : false,
        showSearch: false,
        onSelectOption: this.props.onCreateItem
      },
      {
        title: "Add Existing",
        id: "importExisting",
        options: this.props.availableItems,
        showTitle: true,
        showSearch: true,
        onSelectOption: this.props.onSelectAvailableItem
      }
    ]);

    return wrapEditingComponent(
      <div
        className={`narrativeAddNode ${this.props.linkStyle ? "linkStyle" : ""} ${
          orientationStyle ? orientationStyle : ""
        }`}
        style={nodeStyle}
      >
        <SplitButton
          id={this.props.id}
          label={this.props.label}
          icon="sidebarAdd"
          onClick={onClick}
          clickTogglesMenu={true}
          dropdownActionLabel="Create new"
          optionGroups={optionGroups}
          linkStyle={this.props.linkStyle}
          orientationStyle={orientationStyle}
          ref={this.props.innerRef}
          useMobilePortal={true}
          togglePopoverCallback={this.props.togglePopoverCallback}
        />
      </div>
    );
  }
}

NarrativeAddNodeView.propTypes = {
  id: PropTypes.string.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  onClick: PropTypes.func,
  orderedNarrativeTypes: ImmutablePropTypes.list,
  availableItems: ImmutablePropTypes.list,
  onSelectAvailableItem: PropTypes.func,
  onCreateItem: PropTypes.func,
  label: PropTypes.string,
  linkStyle: PropTypes.bool,
  narrativeViewSettings: PropTypeShapes.narrativeViewSettings.isRequired,
  depth: PropTypes.number,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  togglePopoverCallback: PropTypes.func
};

NarrativeAddNodeView.defaultProps = {
  label: "Add"
};

//export default NarrativeAddNodeView;

export default React.forwardRef((props, ref) => <NarrativeAddNodeView innerRef={ref} {...props} />);
